module.exports = __webpack_public_path__ + "img/2A2A2A_DBDBDB_6A6A6A_949494-256px.eaa49983.png";